import { useState, forwardRef, useRef, useMemo } from 'react'
import { useOnClickOutside, useToggle, useIntl } from 'hooks'
import { format } from 'utils/datetime'
import ContextMenu from 'components/ContextMenu'
import { ListItem, TitleStack, TitleStackMetaItem } from 'components/Zui'
import './index.css'

const CollectionListItem = (
    {
        onClick,
        collection,
        selectedCollection,
        contextMenu,
        handleEditCollection,
        handleDeleteCollection,
        handleShareCollection,
        handleDownload,
    },
    ref
) => {
    const { t } = useIntl()
    const myRef = useRef(null)
    const { isOpen, onClose, onToggle } = useToggle()
    const [pageEnd, setPageEnd] = useState(false)

    useOnClickOutside(myRef, onClose, collection.id)

    const menu = contextMenu?.map(m => {
        if (m.id === 'share') m.onClick = () => handleShareCollection(collection)
        if (m.id === 'edit') m.onClick = () => handleEditCollection(collection)
        if (m.id === 'delete') m.onClick = () => handleDeleteCollection(collection)
        if (m.id === 'download') m.onClick = () => handleDownload(collection.id)
        return m
    })

    const titleStack = useMemo(
        () => (
            <TitleStack size="xs" key={collection.fileCount}>
                <h2>{collection.name}</h2>
                {collection.updatedDateTime && (
                    <TitleStackMetaItem slot="meta" style={{ display: 'inline-block' }}>
                        {format(collection.updatedDateTime, 'dd/MM/yyyy')}
                    </TitleStackMetaItem>
                )}
                <TitleStackMetaItem slot="meta" style={{ display: 'inline-block' }}>
                    {collection.fileCount}{' '}
                    {isNaN(collection?.fileCount) || collection.fileCount > 1
                        ? t('files')
                        : t('file')}
                </TitleStackMetaItem>
            </TitleStack>
        ),
        [collection]
    )

    return (
        <div className="collection-list-item-wrap" style={{ position: 'relative' }} ref={ref}>
            <ListItem
                size="l"
                hierarchy="first"
                style={{ paddingLeft: '32px', height: '72px', overflow: 'hidden' }}
                onClick={() => onClick(collection.id)}
                emphasis={selectedCollection === collection.id ? 'active' : 'default'}
            >
                {titleStack}
            </ListItem>
            {contextMenu && contextMenu.length > 0 && (
                <div
                    className="context-menu-icon"
                    onClick={e => {
                        if (window.innerHeight > 700) {
                            if (e.view.innerHeight - e.screenY < 400) {
                                setPageEnd(true)
                                onToggle()
                            } else {
                                setPageEnd(false)
                                onToggle()
                            }
                        }
                        if (window.innerHeight > 400 && window.innerHeight < 700) {
                            if (e.view.innerHeight - e.screenY < 100) {
                                setPageEnd(true)
                                onToggle()
                            } else {
                                setPageEnd(false)
                                onToggle()
                            }
                        }
                    }}
                >
                    <div
                        className={`${isOpen && 'opened-context-menu'} btn-context`}
                        data-ref={collection.id}
                    >
                        <zui-icon-common-more-centered
                            data-ref={collection.id}
                            size="s16"
                            slot="icon"
                            theme="zbds-light"
                        ></zui-icon-common-more-centered>
                    </div>
                </div>
            )}
            {isOpen && contextMenu && (
                <ContextMenu
                    ref={myRef}
                    onClick={onClose}
                    className={pageEnd ? ['context-menu-last-item-collection'] : []}
                    options={menu}
                />
            )}
        </div>
    )
}

export default forwardRef(CollectionListItem)
